// extracted by mini-css-extract-plugin
export default {"discount_modal":"DiscountModal_discount_modal__2JVdY"};